// src/hooks/useAlerts.ts
import { useSnackbar } from 'notistack';

const useAlerts = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showAlert = (message: string, variant: 'default' | 'error' | 'success' | 'warning' | 'info' = 'default') => {
    enqueueSnackbar(message, { variant });
  };

  return { showAlert };
};

export default useAlerts;
